var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterAircon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 -65)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(-260 65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 27.712,
    height: 19.963,
    rx: 1.083,
    transform: "translate(-256.355 72.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.083-.75H26.629a1.835,1.835,0,0,1,1.833,1.833v17.8a1.835,1.835,0,0,1-1.833,1.833H1.083A1.835,1.835,0,0,1-.75,18.881V1.083A1.835,1.835,0,0,1,1.083-.75ZM26.629,19.213a.333.333,0,0,0,.333-.333V1.083A.333.333,0,0,0,26.629.75H1.083a.333.333,0,0,0-.333.333v17.8a.333.333,0,0,0,.333.333Z",
    transform: "translate(-256.355 72.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-242.5 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-245.951 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-249.404 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-239.049 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-235.596 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-252.855 75.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,14.713a.75.75,0,0,1-.75-.75V0A.75.75,0,0,1,0-.75.75.75,0,0,1,.75,0V13.963A.75.75,0,0,1,0,14.713Z",
    transform: "translate(-232.145 75.519)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterAircon);
export default __webpack_public_path__ + "static/media/icon_filter_aircon.1a9bb2c51f4ba61db18f2963f31d8a2a.svg";
export { ForwardRef as ReactComponent };